module.exports = __webpack_public_path__ + "static/media/home-2.075976f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-2.svg
// module id = 1325
// module chunks = 1